<main
    class="bg-cover bg-center bg-no-repeat bg-fixed h-screen w-full flex items-center justify-center lg:grid grid-cols-2 overflow-y-auto"
    style="background-image: url('./assets2023/img/bg_login.jpg');"
>

    <div class="bg-white rounded-lg lg:rounded-none m-8 lg:m-0 p-6 shadow max-h-90vh lg:max-h-screen lg:h-full overflow-y-auto lg:flex flex-col items-center justify-center">

        <div class="max-w-850px lg:h-full flex flex-col">

            <a href="javascript:;" (click)="backToLogin($event)" class="text-sm font-bold underline">
                {{ 'remember_goto' | translate }} <strong>{{ 'remember_login' | translate }}</strong>
            </a>

            <!-- Main Image -->
            <div class="flex justify-center mb-2">
                <img src="./assets2023/img/logo.svg" alt="Logo" class="w-75px lg:w-145px h-65px lg:h-85px" />
            </div>
            <!-- END Main Image -->

            <!-- Title -->
            <h1 class="text-xl font-semibold text-center">
                {{ 'signup_title_form' | translate }}
            </h1>
            <!-- END Title -->

            <!-- Description -->
            <p class="text-sm mt-2">
                {{ 'signup_text_1' | translate }}
                {{ 'signup_text_3' | translate }} <strong>965 494 000</strong>.
            </p>
            <!-- END Description -->

            <!-- Form -->
            <form
                id="form_sign_up"
                [formGroup]="signupForm"
                (submit)="sendForm($event)">

                <div class="flex flex-col space-y-5 mt-6 text-sm">

                    <!-- Company name -->
                    <div>
                        <label for="Company">
                            {{ 'signup_form_social' | translate }}
                        </label>
                        <input
                            type="text"
                            id="Company"
                            name="Company"
                            formControlName="Company"
                            ngDefaultControl
                            class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px" />
                            <p
                                *ngIf="isFieldValid('Company')"
                                class="text-featured text-xs"
                                >
                                {{ 'signup_form_company_required' | translate }}
                            </p>

                    </div>

                    <!-- Commercial name & CIF -->
                    <div class="grid sm:grid-cols-2 gap-6">
                        <!-- Commercial name -->
                        <div>
                            <label for="LEADCF39">
                                {{ 'signup_form_name' | translate }}
                            </label>
                            <input
                                type="text"
                                formControlName="LEADCF39"
                                name="LEADCF39"
                                ngDefaultControl
                                class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px" />
                                <p
                                    *ngIf="isFieldValid('LEADCF39')"
                                    class="text-featured text-xs"
                                    >
                                    {{ 'signup_form_name_company_required' | translate }}
                                </p>
                        </div>

                        <!-- CIF -->
                        <div>
                            <label for="LEADCF8">
                                {{ 'signup_form_cif' | translate }}
                            </label>
                            <input
                                type="text"
                                formControlName="LEADCF8"
                                name="LEADCF8"
                                class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                                ngDefaultControl
                            >
                            <p
                                *ngIf="isFieldValid('LEADCF8')"
                                class="text-featured text-xs"
                                >
                                <span
                                *ngIf="signupForm.controls.LEADCF8.errors.required"
                            >
                                {{ "signup_form_cif_required" | translate }}<br>
                                </span>
                                <span
                                    *ngIf="signupForm.controls.LEADCF8.errors.minlength"
                                >
                                    {{ "signup_form_cif_minlength" | translate }}<br>
                                </span>
                                <span
                                    *ngIf="signupForm.controls.LEADCF8.errors.pattern"
                                    >
                                        {{ "signup_form_cif_pattern" | translate }}
                                </span>
                            </p>
                        </div>
                    </div>

                    <!-- Name & Surname -->
                    <div class="grid sm:grid-cols-2 gap-6">
                        <!-- Name -->
                        <div>
                            <label for="First Name">
                                {{ 'signup_form_first_name' | translate }}
                            </label>
                            <input
                                formControlName="First Name"
                                name="First Name"
                                class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                                ngDefaultControl
                            >
                            <p
                                *ngIf="isFieldValid('First Name')"
                                class="text-featured text-xs"
                                >
                                {{ 'signup_form_first_name_required' | translate }}
                            </p>
                        </div>

                        <!-- Surname -->
                        <div>
                            <label for="Last Name">
                                {{ 'signup_form_last_name' | translate }}
                            </label>
                            <input
                                formControlName="Last Name"
                                name="Last Name"
                                class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                                ngDefaultControl
                            >
                            <p
                                *ngIf="isFieldValid('Last Name')"
                                class="text-featured text-xs"
                                >
                                {{ 'signup_form_last_name_required' | translate }}
                            </p>
                        </div>
                    </div>

                    <!-- Address -->
                    <div>
                        <label for="Street">
                            {{ 'signup_form_address' | translate }}
                        </label>
                        <input
                            formControlName="Street"
                            name="Street"
                            class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                            ngDefaultControl>
                            <p
                                *ngIf="isFieldValid('Street')"
                                class="text-featured text-xs"
                                >
                                {{ 'signup_form_address_required' | translate }}
                            </p>
                    </div>

                    <!-- CP & City & Province -->
                    <div class="grid sm:grid-cols-3 gap-6">
                        <!-- CP -->
                        <div>
                            <label for="Zip Code">
                                {{ 'signup_form_code' | translate }}
                            </label>
                            <input
                                formControlName="ZipCode"
                                name="Zip Code"
                                class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                                ngDefaultControl>
                            <p
                                *ngIf="isFieldValid('ZipCode')"
                                class="text-featured text-xs"
                                >
                                <span
                                    *ngIf="signupForm.controls.ZipCode.errors.required"
                                >
                                    {{ "signup_form_code_required" | translate }}
                                </span>
                                <span
                                    *ngIf="signupForm.controls.ZipCode.errors.pattern"
                                >
                                    {{ "signup_form_code_pattern" | translate }}
                                </span>
                            </p>
                        </div>

                        <!-- City -->
                        <div>
                            <label for="city">
                                {{ 'signup_form_city' | translate }}
                            </label>
                            <input
                                formControlName="City"
                                name="City"
                                class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                                ngDefaultControl>
                                <p
                                    *ngIf="isFieldValid('City')"
                                    class="text-featured text-xs"
                                    >
                                    {{ 'signup_form_city_required' | translate }}
                                </p>
                        </div>

                        <!-- Province -->
                        <div>
                            <label for="State">
                                {{ 'signup_form_state' | translate }}
                            </label>
                            <div class="mt-1 rounded-lg border border-light focus:outline-light-blue px-2 h-45px w-full bg-white flex items-center pr-1">
                                <select
                                    id="State"
                                    formControlName="State"
                                    name="State"
                                    required
                                    class="bg-white w-full focus:outline-none cursor-pointer pr-1"
                                    ngDefaultControl
                                >
                                    <option value="" disabled selected></option>
                                    <option *ngFor="let province of provinces" [value]="province.iso">
                                        {{ province.name }}
                                    </option>
                                </select>
                            </div>
                            <p
                                *ngIf="isFieldValid('State')"
                                class="text-featured text-xs"
                                >
                                {{ 'signup_form_state_required' | translate }}
                            </p>
                        </div>
                    </div>

                    <!-- Email & Phone -->
                    <div class="grid sm:grid-cols-2 gap-6">
                        <!-- Email -->
                        <div>
                            <label for="Email">
                                {{ 'signup_form_email' | translate }}
                            </label>
                            <input
                                formControlName="Email"
                                name="Email"
                                class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                                type="email"
                                ngDefaultControl
                            >
                            <p
                                *ngIf="isFieldValid('Email')"
                                class="text-featured text-xs"
                                >
                                {{ 'signup_form_email_pattern' | translate }}
                            </p>
                        </div>

                        <!-- Phone -->
                        <div>
                            <label for="Phone">
                                {{ 'signup_form_phone' | translate }}
                            </label>
                            <input
                                formControlName="Phone"
                                name="Phone"
                                class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                                type="tel"
                                (keypress)="onKeyPressFieldNumber($event)"
                                ngDefaultControl
                            >
                            <p
                                *ngIf="isFieldValid('Phone')"
                                class="text-featured text-xs"
                                >
                                {{ 'signup_form_phone_required' | translate }}
                            </p>
                        </div>
                    </div>
                    <div>captcha {{ captchaResolved }}</div>

                    <div class="grid sm:grid-cols-2 gap-6">
                        <ng-hcaptcha
                            (verify)="onCaptchaVerify()"
                            (expired)="onCaptchaExpired()"
                            (error)="onCaptchaError()"
                        ></ng-hcaptcha>
                    </div>
                    <!-- Checks -->
                    <div class="space-y-1">
                        <div class="text-xs font-medium">
                            <div class="flex items-center gap-2">
                                <input
                                    value='SI'
                                    type="checkbox"
                                    formControlName="privacyTool"
                                    name="privacyTool"
                                    id="privacyTool"
                                >
                                <label for="privacyTool" class="mt-px cursor-pointer">{{ "signup_form_privacy_tool" | translate }}</label>
                                <p
                                    *ngIf="isFieldValid('privacyTool')"
                                    class="text-featured text-xs"
                                    >
                                    {{ 'signup_form_privacy_tool_required' | translate }}
                                </p>
                            </div>
                        </div>

                        <div class="text-xs font-medium">
                            <div class="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    formControlName="Autorizo"
                                    name="LEADCF101"
                                    id="LEADCF101"
                                    class="flex-shrink-0"
                                >
                                <label for="LEADCF101" class="mt-px cursor-pointer">{{ "signup_form_privacy_promotions" | translate }}</label>
                            </div>
                        </div>
                    </div>

                    <app-alert-text *ngIf="typeOKMsg" type="success">{{ 'signup_form_success' | translate }}</app-alert-text>
                    <app-alert-text *ngIf="msg" type="error">{{ msg }}</app-alert-text>
                    <app-alert-text *ngIf="sendIntent && !captchaResolved" type="error">{{ 'signup_form_captcha_error' | translate }}</app-alert-text>

                    <!-- Submit button -->
                    <div class="flex justify-center">
                        <button type="submit" class="text-white bg-secondary border-secondary hover:bg-white hover:text-primary hover:border-primary font-semibold text-md rounded border transition duration-300 px-8 h-45px">
                            {{ 'signup_register' | translate }}
                        </button>
                    </div>
                </div>

            </form>

            <app-languages-links class="hidden lg:flex flex-1 justify-center items-end mt-9"></app-languages-links>

            <div class="text-2xs mt-6 lg:pb-4">
                {{ 'signup_legal' | translate }}
            </div>
        </div>

    </div>
</main>
